var _defineProperty = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _assertThisInitialized = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var Base = require('./Base');

var Campaign = /*#__PURE__*/function (_Base) {
  "use strict";

  _inherits(Campaign, _Base);

  var _super = _createSuper(Campaign);

  function Campaign() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$id = _ref.id,
        id = _ref$id === void 0 ? '' : _ref$id,
        _ref$creator = _ref.creator,
        creator = _ref$creator === void 0 ? '' : _ref$creator,
        _ref$depositAsset = _ref.depositAsset,
        depositAsset = _ref$depositAsset === void 0 ? '' : _ref$depositAsset,
        _ref$depositAmount = _ref.depositAmount,
        depositAmount = _ref$depositAmount === void 0 ? '' : _ref$depositAmount,
        _ref$validUntil = _ref.validUntil,
        validUntil = _ref$validUntil === void 0 ? null : _ref$validUntil,
        _ref$title = _ref.title,
        title = _ref$title === void 0 ? '' : _ref$title,
        _ref$adUnits = _ref.adUnits,
        adUnits = _ref$adUnits === void 0 ? [] : _ref$adUnits,
        _ref$validators = _ref.validators,
        validators = _ref$validators === void 0 ? [] : _ref$validators,
        _ref$pricingBounds = _ref.pricingBounds,
        pricingBounds = _ref$pricingBounds === void 0 ? null : _ref$pricingBounds,
        _ref$pricingBoundsCPM = _ref.pricingBoundsCPMUserInput,
        pricingBoundsCPMUserInput = _ref$pricingBoundsCPM === void 0 ? null : _ref$pricingBoundsCPM,
        _ref$maxPerImpression = _ref.maxPerImpression,
        maxPerImpression = _ref$maxPerImpression === void 0 ? '' : _ref$maxPerImpression,
        _ref$minPerImpression = _ref.minPerImpression,
        minPerImpression = _ref$minPerImpression === void 0 ? '' : _ref$minPerImpression,
        _ref$targeting = _ref.targeting,
        targeting = _ref$targeting === void 0 ? [] : _ref$targeting,
        _ref$targetingRules = _ref.targetingRules,
        targetingRules = _ref$targetingRules === void 0 ? null : _ref$targetingRules,
        _ref$audienceInput = _ref.audienceInput,
        audienceInput = _ref$audienceInput === void 0 ? null : _ref$audienceInput,
        _ref$minTargetingScor = _ref.minTargetingScore,
        minTargetingScore = _ref$minTargetingScor === void 0 ? null : _ref$minTargetingScor,
        _ref$created = _ref.created,
        created = _ref$created === void 0 ? null : _ref$created,
        _ref$nonce = _ref.nonce,
        nonce = _ref$nonce === void 0 ? null : _ref$nonce,
        _ref$withdrawPeriodSt = _ref.withdrawPeriodStart,
        withdrawPeriodStart = _ref$withdrawPeriodSt === void 0 ? null : _ref$withdrawPeriodSt,
        _ref$eventSubmission = _ref.eventSubmission,
        eventSubmission = _ref$eventSubmission === void 0 ? {} : _ref$eventSubmission,
        _ref$activeFrom = _ref.activeFrom,
        activeFrom = _ref$activeFrom === void 0 ? null : _ref$activeFrom,
        _ref$temp = _ref.temp,
        temp = _ref$temp === void 0 ? {} : _ref$temp,
        _ref$status = _ref.status,
        status = _ref$status === void 0 ? {} : _ref$status,
        _ref$state = _ref.state,
        state = _ref$state === void 0 ? {} : _ref$state;

    _classCallCheck(this, Campaign);

    _this = _super.call(this);
    _this.id = id;
    _this.creator = creator;
    _this.depositAsset = depositAsset;
    _this.depositAmount = depositAmount;
    _this.validUntil = validUntil;
    _this.title = title;
    _this.adUnits = adUnits;
    _this.validators = validators;
    _this.pricingBounds = pricingBounds;
    _this.pricingBoundsCPMUserInput = pricingBoundsCPMUserInput;
    _this.maxPerImpression = maxPerImpression;
    _this.minPerImpression = minPerImpression;
    _this.targeting = targeting;
    _this.targetingRules = targetingRules;
    _this.audienceInput = audienceInput;
    _this.minTargetingScore = minTargetingScore;
    _this.created = created;
    _this.nonce = nonce;
    _this.withdrawPeriodStart = withdrawPeriodStart;
    _this.eventSubmission = eventSubmission;
    _this.activeFrom = activeFrom;
    _this.temp = temp;
    _this.status = status;
    _this.state = state;
    return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
  }

  _createClass(Campaign, [{
    key: "spec",
    get: function get() {
      return this.deepCopyObj({
        title: this.title,
        adUnits: this.adUnits,
        validators: this.validators,
        pricingBounds: this.pricingBounds,
        maxPerImpression: this.maxPerImpression,
        minPerImpression: this.minPerImpression,
        targetingRules: this.targetingRules,
        minTargetingScore: this.minTargetingScore,
        created: this.created,
        nonce: this.nonce,
        withdrawPeriodStart: this.withdrawPeriodStart,
        eventSubmission: this.eventSubmission,
        activeFrom: this.activeFrom
      });
    }
  }, {
    key: "openReady",
    get: function get() {
      var _this$deepCopyObj;

      return this.deepCopyObj((_this$deepCopyObj = {
        id: this.id,
        creator: this.creator,
        depositAsset: this.depositAsset,
        depositAmount: this.depositAmount,
        validUntil: this.validUntil
      }, _defineProperty(_this$deepCopyObj, "validUntil", this.validUntil), _defineProperty(_this$deepCopyObj, "spec", this.spec), _this$deepCopyObj));
    }
  }, {
    key: "mediaUrl",
    get: function get() {
      return this.adUnits[0] ? this.adUnits[0].mediaUrl : '';
    }
  }, {
    key: "audienceInputMarket",
    get: function get() {
      return this.audienceInput && this.audienceInput.version && Object.keys(this.audienceInput.inputs).length ? this.deepCopyObj({
        version: this.audienceInput.version,
        inputs: this.audienceInput.inputs,
        pricingBoundsCPMUserInput: this.pricingBoundsCPMUserInput || this.audienceInput.pricingBoundsCPMUserInput
      }) : null;
    }
  }, {
    key: "marketUpdate",
    get: function get() {
      return this.deepCopyObj({
        title: this.title,
        targetingRules: this.targetingRules,
        audienceInput: this.audienceInputMarket
      });
    }
  }, {
    key: "marketDbUpdate",
    get: function get() {
      return this.deepCopyObj({
        title: this.title,
        targetingRules: this.targetingRules,
        audienceInput: this.audienceInputMarket,
        modified: this.modified
      });
    }
  }]);

  return Campaign;
}(Base);

module.exports = Campaign;